import React from 'react';
import { color, spacing } from '../../styles/theme';
import HyperLink from '../elements/HyperLink';
import RouteLink from '../navigation/RouteLink';
import CallToActionBottomBox from './CallToActionBottomBox';
import CardContainer from './CardContainer';
import { IconName } from './Icon';

interface TextIconActionCardProps {
  bottomText: string;
  bottomIcon: IconName;
  routeLinkPath: string;
  children?: React.ReactNode;
}

/* TODO: Should refactor SearchResultsCard to use this component. */

const TextIconActionCard: React.FunctionComponent<TextIconActionCardProps> = ({
  children,
  bottomText,
  bottomIcon,
  routeLinkPath,
  ...rest
}) => {
  return (
    <div className="text-icon-action-card" {...rest}>
      <CardContainer>
        <RouteLink path={routeLinkPath}>
          <HyperLink noLinkStateStyles>
            <div className="container" data-cy="text-icon-action-card-link">
              <div className="top">{children}</div>
              <div className="divider" />
              <div className="bottom">
                <CallToActionBottomBox
                  primaryText={bottomText}
                  icon={bottomIcon}
                />
              </div>
            </div>
          </HyperLink>
        </RouteLink>
      </CardContainer>

      {/*language=CSS*/}
      <style jsx global>{`
        .container {
          padding-top: ${spacing.two};
          padding-bottom: ${spacing.two};
        }
        .top,
        .bottom {
          margin: 0 ${spacing.two};
        }
        .divider {
          margin-top: ${spacing.three};
          margin-bottom: ${spacing.two};
          border-bottom: 1px dashed ${color.lightGray};
        }
      `}</style>
    </div>
  );
};

export default TextIconActionCard;
